export default {
  title: "Дизайни корти Wallet",
  emptyState: {
    pageUnavailable: "Саҳифа ҳоло дастрас нест",
    description:
      "Барои дастрасӣ ба саҳифа, бояд тариф «Промо» ё «Про+»-ро харед",
    buttonText: "Ба тарифҳо",
  },
  tradingPoint: "Нуқтаи савдо",
  actions: {
    resetDesign: "Баргардонидани дизайни асосӣ",
    saveChanges: "Захира кардани тағйирот",
  },
  walletCardPreview: {
    clientName: "Номи муштарӣ",
    balance: "Бақия",
    discount: "Тахфиф",
  },
  walletCardSettings: {
    colors: {
      title: "Рангҳои корти Wallet",
      background: "Ранги замина",
      text: "Ранги матн",
    },
    logo: {
      title: "Логотипи муассиса",
      noLogo: "Логотип нест",
      hasLogo: "Логотип вуҷуд дорад",
      aspectRatio: "Таносуби ҷонишин — 1:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл то 5 Мб",
    },
    stripe: {
      title: "Пойбанди замина",
      noStripe: "Пойбанд нест",
      image: "Тасвир",
      colorFill: "Пур кардани ранг",
      aspectRatio: "Таносуби ҷонишин — 3:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл то 5 Мб",
      color: "Ранги пойбанд",
    },
  },
};
